
import dust from "dustjs-linkedin";


(function(){dust.register("grammar/hint",body_0);function body_0(chk,ctx){return chk.write("<div class=\"grammar-hint\" data-key=\"").reference(ctx.get(["key"], false),ctx,"h").write("\"><header><div class=\"toggle\">").helper("svg",ctx,{},{"path":"arrow-large"}).write("</div><div class=\"title\">").reference(ctx.get(["title"], false),ctx,"h",["s"]).write("</div></header><main>").reference(ctx.get(["html"], false),ctx,"h",["s"]).write("</main></div>");}return body_0;})();

export default 0;
